/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Currency } from "../enumeration/currency";


export class CurrencyUtils {
  /** map of common symbols → named HTML entities */
  private static namedEntities: Record<string,string> = {
    '$':  '&dollar;',
    '€':  '&euro;',
    '£':  '&pound;',
  };

  /**
   * Get the raw currency symbol via Intl.
   */
  static symbol(
    code: Currency | string,
    locale = 'en-GB',
    format: 'narrow' | 'wide' = 'narrow'
  ): string {
    const parts = new Intl.NumberFormat(locale, {
      style:    'currency',
      currency: code,
      // 'symbol' gives $, 'code' gives USD
      currencyDisplay: format === 'wide' ? 'code' : 'symbol'
    }).formatToParts(0);

    return parts.find(p => p.type === 'currency')?.value ?? code;
  }

  /**
   * Return the HTML entity, e.g. '&pound;' (falls back to numeric if unknown).
   */
  static htmlEntity(
    code: Currency | string,
    locale = 'en-GB',
    format: 'narrow' | 'wide' = 'narrow'
  ): string {
    const sym = this.symbol(code, locale, format);

    // named entity?
    if (sym in this.namedEntities) {
      return this.namedEntities[sym];
    }
    // numeric fallback
    const cp = sym.codePointAt(0);
    return cp != null ? `&#${cp};` : sym;
  }
}